import { BaseOptionModel } from './base-option-model';

export interface IsTreatmentFromAiOptionModel extends BaseOptionModel<boolean | null | undefined> {}
